import API from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';
import Response from '../../classes/Response/Response';
import CustomError from '../../classes/CustomError/CustomError';

const DemoFormService = () => {
  const createProject = async (values) => {
    const [latitude, longitude] = values.gps.split(',').map((c) => c.trim());
    const projectType =
      values.project_type === "other"
        ? (values.project_type_other || "").trim()
        : values.project_type;

    const body = {
      name: values.assetProjectName,
      is_private: false,
      country: values.location,
      region: '0',
      province: '0',
      latitude,
      longitude,
      contract_start_date: '0',
      contract_end_date: '0',
      project_type: projectType,
      co2Goal: '0',
      co2_annual_estimated: '0',
      ton_price: '0',
      area: '0',
      biomass: '0',
      ton_co2_issued: '0',
      volume: 'o',
      info: {
        en: {
          company_name: values.companyName,
          measure: values.quantityUnit,
          description: values.openEnded,
          name: values.assetProjectName,
          project_type: projectType,
          country: values.location,
        },
      },
      enabled: false,
    };

    const api = new API(
      `${URL.URL_SERVER}/projects`,
      {},
      { withCredentials: true }
    );
    const http_response = await api.post(body);
    if (http_response instanceof CustomError) return http_response;
    return new Response(http_response);
  };

  const createOwner = async (values) => {
    const body = {
      email: values.email,
      cellphone: values.phoneNumber,
    };

    const api = new API(
      `${URL.URL_SERVER}/owners`,
      {},
      { withCredentials: true }
    );
    const http_response = await api.post(body);
    if (http_response instanceof CustomError) return http_response;
    return new Response(http_response);
  };

  const associateOwnerProject = async (ownerId, projectId) => {
    const api = new API(
      `${URL.URL_SERVER}/owners/${ownerId}/projects/${projectId}`,
      {},
      { withCredentials: true }
    );
    const http_response = await api.post({});
    if (http_response instanceof CustomError) return http_response;
    return new Response(http_response);
  };

  const createSession = async () => {
    try {
      const api = new API(
        `${URL.URL_SERVER}/sessions`,
        {},
        { withCredentials: true }
      );
      const http_response = await api.post({});

      if (http_response instanceof CustomError) {
        console.error('Error en createSession (CustomError):', http_response);
        throw http_response;
      }

      const response = new Response(http_response);
      console.log('Response creada exitosamente:', response);
      return response;
    } catch (error) {
      console.error('Error capturado en createSession:', error);
      throw error;
    }
  };

  const contact = async (emailString) => {
    const api = new API(
      `${URL.URL_SERVER}/contacts`,
      {},
      { withCredentials: true }
    );
    const http_response = await api.post({ email: emailString });
    if (http_response instanceof CustomError) return http_response;
    return new Response(http_response);
  };

  return {
    createProject,
    createOwner,
    associateOwnerProject,
    contact,
    createSession,
  };
};

export default DemoFormService;
